import React from "react";
import { Container } from "reactstrap";
import WelcomeSection from "./WelcomeSection";

function AuthContainer(props) {
  return (
    <div className="auth-container">
      <Container
        fluid
        className="d-flex align-items-center justify-content-center min-vh-100"
      >
        <div className="w-full max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row w-full gap-16">
            <div className="flex-1 min-w-0 flex items-center">
              <WelcomeSection />
            </div>
            <div className="flex-1 min-w-0">{props.children}</div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default AuthContainer;
